// extracted by mini-css-extract-plugin
export default {"root":"OrderTagEditor_root__y8Qwe"};